import { useSelector } from 'react-redux';
import './TruInk.css'
import { useEffect ,useState } from 'react';
import TruInkSiteSelector from '../Components/TruInkSiteSelector';
import TruInkSelectedSiteUi from '../Components/TruInkSelectedSiteUi';
import Box from "@mui/material/Box";

function TruInk() {
      const selectedSite = useSelector((state) => state.truInk.selectedSite);
      const selectedOption = useSelector((state) => state.truInk.selectedOption);
      const [headerHeight, setHeaderHeight] = useState(0);

      useEffect(() => {
            const header = document.getElementById("main-header");

            if (header) {
                  setHeaderHeight(header.offsetHeight);
            }
      }, []);


      return (
            <Box
                  className="mainContainer"
                  sx={{
                        height: {
                              md: "90vh",
                              xs: `calc(104vh - ${headerHeight}px)`,
                        },
                        display: "flex",
                        flexDirection: "column",
                        ml: {
                              md: "10%",
                              xs: "0px"
                        },
                        position: "relative",
                        overflow: "hidden",
                  }}
            >
                  <div class="wave1"></div>
                  <div class="wave2"></div>
                  <div class="wave3"></div>
                  <div class="wave4"></div>
                  <Box className="tableAndButtonContainer">
                        <Box
                              sx={{
                                    ml: {
                                          xs: "0px",
                                          md: "15%",
                                          lg: "10%"
                                    },
                                    paddingTop: {
                                          xs: "12%",
                                          sm: "7%",
                                          md: "3%"
                                    }
                              }}
                        >
                              {selectedOption === "TruInk" && selectedSite == null && (
                                    <TruInkSiteSelector />
                              )}

                              {selectedOption === "TruInk" && selectedSite && (
                                    <TruInkSelectedSiteUi />
                              )}
                        </Box>
                  </Box>

            </Box>
      )
}

export default TruInk